<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '500px' }"
    header="Grupo Detalle"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="nombre"
            ><strong>NOMBRE GRUPO: </strong>
            <span class="p-invalid">*</span></label
          >
          <InputText
            id="nombre"
            v-model="data_grupo.nombre"
            required="true"
            autofocus
            @keydown.enter="saveGrupo"
          />
          <small class="p-invalid" v-if="errors.nombre">{{
            errors.nombre[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-6">
          <label for="requiere_modal"
            ><strong>¿Abrir Salsas/Extras?: </strong></label
          >
          <Dropdown
            id="requiere_modal"
            v-model="data_grupo.requiere_modal"
            :options="opcionesSiNo"
            optionLabel="label"
            optionValue="value"
            placeholder="Comportamiento..."
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="mostrar_stock"
            ><strong>Mostrar Stock: </strong></label
          >
          <div class="flex align-items-center mt-2">
            <Checkbox id="mostrar_stock" v-model="data_grupo.mostrar_stock" :binary="true" />
            <label for="mostrar_stock" class="ml-2">Sí, mostrar cantidad</label>
          </div>
        </div>
        <div class="field col-12 md:col-12">
          <label for="estado"
            ><strong>Estado: </strong><span class="p-invalid">*</span></label
          >
          <Dropdown
            id="estado"
            v-model="data_grupo.estado"
            :disabled="!data_grupo.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start"
          ><strong>Campos Requeridos: </strong>
          <span class="p-invalid">*</span></label
        >
      </div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
        :disabled="!enviado ? false : true"
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        class="p-button-primary p-button-lg"
        @click="saveGrupo"
        :disabled="!enviado ? false : true"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import GrupoService from "@/service/GrupoService";
export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    grupo: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      mostrarModal: this.show,
      data_grupo: this.grupo,
      enviado: false,
      estados: [
        { label: "ACTIVO", value: 1 },
        { label: "INACTIVO", value: 0 },
      ],
      opcionesSiNo: [
        { label: "SÍ (Abre ventana de opciones)", value: 1 },
        { label: "NO (Venta directa al carrito)", value: 0 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
    };
  },
  grupoService: null,
  created() {
    this.grupoService = new GrupoService();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
    },
    saveGrupo() {
      this.errors = {};
      this.enviado = true;
      //editar grupo
      if (this.data_grupo.id) {
        let grupo_enviar = {
          ...this.data_grupo,
          estado: typeof this.data_grupo.estado === 'object' ? this.data_grupo.estado.value : this.data_grupo.estado,
          requiere_modal: this.data_grupo.requiere_modal ? 1 : 0,
          mostrar_stock: this.data_grupo.mostrar_stock ? 1 : 0
        };
        this.grupoService
          .updateGrupo(grupo_enviar)
          .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 3000,
              });
              this.$emit("actualizarListado");
              this.ocultarDialog();
            }
            this.enviado = false;
          });
      } else {
        //CREANDO UN NUEVO PUNTO DE VENTA
        let tmp = {
          ...this.data_grupo,
          estado: typeof this.data_grupo.estado === 'object' ? this.data_grupo.estado.value : this.data_grupo.estado,
          requiere_modal: this.data_grupo.requiere_modal ? 1 : 0,
          mostrar_stock: this.data_grupo.mostrar_stock ? 1 : 0
        };
        this.grupoService
          .sendGrupo(tmp)
          .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
              this.data_grupo = tmp;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 10000,
              });
              this.$emit("actualizarListado", data.grupo);
              this.ocultarDialog();
            }
            this.enviado = false;
          });
      }
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    grupo(val) {
      this.data_grupo = { ...val };
      if (this.data_grupo.mostrar_stock === undefined) {
        this.data_grupo.mostrar_stock = true;
      } else {
        this.data_grupo.mostrar_stock = !!this.data_grupo.mostrar_stock;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>